import {
  CreateDailyNoteDto,
  UpdateDailyNoteDto,
  ViewDailyNote,
} from '@xeetr/types/models'

import ApiService from './common/API.service'


export class DailyNoteService extends ApiService {
  getDailyNotes = async (from?: string, until?: string): Promise<ViewDailyNote[]> => {
    const params: Record<string, string> = {}
    if (from) params.from = from
    if (until) params.until = until

    const { data } = await this.get<ViewDailyNote[]>(this.buildCommonUrl('daily-notes'), {
      params,
    })
    return data
  }

  createDailyNote = async (note: CreateDailyNoteDto): Promise<ViewDailyNote> => {
    const { data } = await this.post<CreateDailyNoteDto, ViewDailyNote>(
      this.buildCommonUrl('daily-notes'),
      note
    )
    return data
  }

  updateDailyNote = async (id: string, note: UpdateDailyNoteDto): Promise<ViewDailyNote> => {
    const { data } = await this.put<UpdateDailyNoteDto, ViewDailyNote>(
      this.buildCommonUrl(`daily-notes/${id}`),
      note
    )
    return data
  }

  deleteDailyNote = async (id: string): Promise<void> => {
    await this.delete<void>(this.buildCommonUrl(`daily-notes/${id}`))
  }
}
